import { useEffect, useState } from "react";
import flowplayer from "@flowplayer/player";
export const useFlowplayer = (ref) => {
    const [player, setPlayer] = useState();
    useEffect(() => {
        if (ref.current) {
            const newPlayer = flowplayer(ref.current);
            setPlayer(newPlayer);
        }
    }, [ref]);
    return player;
};
